




































export default {
	name: 'GettingStarted',
	data() {
		return {
			loading: false,
			loadingText: this.$t('common.loading'),
			organizationData: {
				licensePerUser: true,
				name: false,
				logo: this.$store.state.ramboxLogo,
				providers: {},
			},
		};
	},
	methods: {
		download(link): void {
			window.open(link);
		},
		async getOrganizationInfo(): Promise<void> {
			try {
				this.loading = true;
				this.loadingText = this.$t('gettingStarted.gettingOrganizationInfo');
				const response = await this.$firebase.functions().httpsCallable('getOrganizationInfo')(this.$route.params.id);
				this.organizationData = response.data;

				this.loading = false;
				this.loadingText = this.$options.data.call(this).loadingText;
				this.$emit('organizationName', this.organizationData.name);
			} catch (error) {
				console.log(error);
				this.loading = false;
				this.loadingText = this.$options.data.call(this).loadingText;
				this.$alert(this.$translateError(error), this.$t('common.error'), {
					confirmButtonText: this.$t('common.ok'),
					callback: action => this.$router.push('/'),
				});
				this.organizationData = this.$options.data.call(this).organizationData;
			}
		},
	},
	mounted() {
		this.$route.params.id && this.getOrganizationInfo();
	},
};
